/**
 * @ Author: DY
 * @ Date: 2022-10-09 10:22:30
 * @ LastEditTime: 2022-10-31 09:59:50
 * @ Description:
 * @ FilePath: \ConcreteCloud.Mobile\src\main.js
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import CnChar from 'cnchar';

import Vant from 'vant';
import 'vant/lib/index.css';

import VueTouch from 'vue-touch';

import '@/services/api';
import './promission';

import * as echarts from 'echarts'; // echarts 5.0引入
Vue.prototype.$echarts = echarts;
// import VueAMap from 'vue-amap';
// Vue.use(VueAMap);
// VueAMap.initAMapApiLoader({
//     key: 'b4007ecc143884e79eab2c515ede82cf',
//     plugin: [
//         'AMap.ToolBar',
//         'AMap.Geolocation',
//         'AMap.Geocoder',
//         'AMap.AMapManager',
//         'AMap.Marker',
//         'AMap.GeometryUtil',
//         'AMap.LngLat',
//         'AMap.Polygon',
//     ],
//     v: '1.4.4',
// });
// window._AMapSecurityConfig = {
//     securityJsCode: '18c398e300fae5db28ab27861cc4c304',
// };

// 调用jquery
import $ from 'jquery';
window.jQuery = $;
Vue.prototype.$ = $;

import '@/assets/styles/global.styl';

// 阿里矢量图标字体引入
import './assets/fonts/icon_font/iconfont.css';
import './assets/fonts/icon_font/iconfont.js';

// 联系人数据格式化
import dataSorting from './assets/js/dataSorting.js';
Vue.use(dataSorting);

// 调用原生方法
import callMobile from './assets/js/callMobile.js';
Vue.use(callMobile);

// token取值
import takeTokenParameters from './assets/js/takeTokenParameters.js';
Vue.use(takeTokenParameters);

// 引入dataV
import dataV from '@jiaminghi/data-view';
Vue.use(dataV);

import '@/assets/fonts/font/font.css';

Vue.config.productionTip = false;

Vue.use(Vant);
Vue.use(CnChar);

Vue.use(VueTouch, { name: 'v-touch' });
VueTouch.config.swipe = {
    threshold: 100, // 手指左右滑动距离
};

// 服务地址(等全局静态变量)
import globalVariable from '@/assets/js/global_variable';
Vue.prototype.GLOBAL = globalVariable;

if (process.env.NODE_ENV === 'development') {
    Vue.config.devtools = true; // 关键配置
}

// 全局过滤器
import * as filters from './assets/js/filters';
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});
window.$globalHub = new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
